"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    fontFamily,
    basicFontSize,
    themeColors,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isMobile
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const tabInlinePadding = 20;
  const calcHorizontalPosition = (0, _react.useCallback)((tabs, selectedTabId) => {
    // Keep tabInlinePadding aligned with pxToRem proportions
    let horizontalPosition = 0;
    const firstTab = tabs?.length && tabs[0]?.id ? document.querySelector(`#tab_${tabs[0].id} button`) : null;
    const selectedTab = document.querySelector(`#tab_${selectedTabId} button`);
    if (selectedTab && firstTab) {
      horizontalPosition = direction === 'ltr' ? selectedTab.getBoundingClientRect().left - firstTab.getBoundingClientRect().left : firstTab.getBoundingClientRect().right - selectedTab.getBoundingClientRect().right;
    }
    return horizontalPosition;
  }, [direction]);
  const ccTabsStyle = (0, _react.useMemo)(() => {
    const ccTabs = (0, _css.css)({
      position: 'relative',
      width: '100%',
      display: 'flex',
      padding: `${pxToRem(1)} 0`,
      overflowX: isMobile ? 'scroll' : 'hidden',
      fontFamily: fontFamily,
      fontSize: basicFontSize,
      '::-webkit-scrollbar': {
        width: 0,
        height: 0
      }
    });
    const ccTabsList = (0, _css.css)({
      padding: 0,
      margin: 0,
      listStyle: 'none',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      display: 'flex'
    });
    const ccTabsTab = (0, _css.css)({
      float: 'right',
      paddingInline: pxToRem(tabInlinePadding),
      paddingBottom: pxToRem(3),
      color: themeColors?.general.text,
      ':first-of-type': {
        paddingInlineStart: 0
      }
    });
    const ccTabsTabHidden = (0, _css.css)({
      paddingInline: pxToRem(tabInlinePadding),
      color: themeColors?.general.text
    });
    const ccTabsTabLabel = (0, _css.css)({
      whiteSpace: 'nowrap'
    });
    const ccTabsTabDots = (0, _css.css)({
      transform: 'rotate(90deg)',
      display: 'inline-block',
      marginInlineEnd: pxToRem(3),
      letterSpacing: pxToRem(0.5),
      fontSize: pxToRem(15)
    });
    const ccTabsSlider = (selectedTabId, tabs) => {
      const prop = direction === 'rtl' ? 'right' : 'left';
      const selectedTab = document.querySelector(`#tab_${selectedTabId} button`);
      const horizontalPosition = calcHorizontalPosition(tabs, selectedTabId);
      const sliderHeight = 2;
      if (selectedTab) {
        const rect = selectedTab.getBoundingClientRect();
        return (0, _css.css)({
          boxSizing: 'content-box',
          fontSize: 1,
          width: rect.width,
          bottom: 0,
          height: pxToRem(sliderHeight),
          top: `calc(100% - ${pxToRem(sliderHeight)})`,
          [prop]: horizontalPosition,
          position: 'absolute',
          backgroundColor: themeColors?.primary.main,
          transition: `width 0.5s ease, ${prop} 0.5s ease`
        });
      }
    };
    return {
      ccTabs,
      ccTabsList,
      ccTabsTab,
      ccTabsTabHidden,
      ccTabsTabLabel,
      ccTabsTabDots,
      ccTabsSlider
    };
  }, [basicFontSize, calcHorizontalPosition, direction, fontFamily, isMobile, pxToRem, themeColors?.general.text, themeColors?.primary.main]);
  return {
    'cc-Tabs': ccTabsStyle.ccTabs,
    'cc-Tabs__list': ccTabsStyle.ccTabsList,
    'cc-Tabs__tab': ccTabsStyle.ccTabsTab,
    'cc-Tabs__tab--hidden': ccTabsStyle.ccTabsTabHidden,
    'cc-Tabs__tab__label': ccTabsStyle.ccTabsTabLabel,
    'cc-Tabs__tab__dots': ccTabsStyle.ccTabsTabDots,
    'cc-Tabs__slider': ccTabsStyle.ccTabsSlider
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;